import React, { ForwardedRef, forwardRef } from 'react'

import { BulletedListButton } from '@app/lib/inputs/RichEditor/blocks/BulletedListButton'
import { HeadingOneButton } from '@app/lib/inputs/RichEditor/blocks/HeadingOneButton'
import { HeadingTwoButton } from '@app/lib/inputs/RichEditor/blocks/HeadingTwoButton'
import { NumberedListButton } from '@app/lib/inputs/RichEditor/blocks/NumberedListButton'
import { Toolbar } from '@app/lib/inputs/RichEditor/editor/Toolbar'
import { MarkBoldButton } from '@app/lib/inputs/RichEditor/marks/MarkBoldButton'
import { MarkItalicButton } from '@app/lib/inputs/RichEditor/marks/MarkItalicButton'
import { MarkUnderlineButton } from '@app/lib/inputs/RichEditor/marks/MarkUnderlineButton'
import { RichEditor, RichEditorInputProps } from '@app/lib/inputs/RichEditor/RichEditor'

export const AuditReportEditor = forwardRef(
  ({ value, onChange, name }: RichEditorInputProps, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <RichEditor
        ref={ref}
        value={value}
        onChange={onChange}
        name={name}
        toolbar={
          <Toolbar>
            <Toolbar.Group>
              <MarkBoldButton />
              <MarkItalicButton />
              <MarkUnderlineButton />
            </Toolbar.Group>

            <Toolbar.Group>
              <BulletedListButton />
              <NumberedListButton />
              <HeadingOneButton />
              <HeadingTwoButton />
            </Toolbar.Group>
          </Toolbar>
        }
      />
    )
  }
)
